import { concatClasses } from "../../../helpers/concatClasses/index.js";
const iconMap = {
  info: "Info",
  urgent: "OctagonX",
  pending: "TriangleAlert",
  success: "Check",
  default: "TriangleAlert"
};
const getIcon = (type) => iconMap[type];
const textColorMap = {
  default: "text-neutral-700",
  urgent: "text-error-300",
  pending: "text-primary-300",
  info: "text-secondary-300",
  success: "text-success-300"
};
const bgColorMap = {
  default: "bg-neutral-100",
  urgent: "bg-error-50",
  pending: "bg-primary-50",
  info: "bg-secondary-50",
  success: "bg-success-50"
};
const getClasses = ({ dsf_level, disabled }) => {
  const classes = [
    "font-sans",
    "dsf-text-xs",
    "flex-auto",
    "flex",
    "flex-col",
    "p-12",
    "rounded-m",
    "text-neutral-700"
  ];
  if (disabled) {
    classes.push("bg-neutral-50");
  } else {
    classes.push(bgColorMap[dsf_level]);
  }
  return concatClasses(classes);
};
const getIconClasses = ({ dsf_level, disabled }) => {
  const classes = ["h-16", "w-16", "flex-shrink-0", "self-baseline"];
  if (disabled) {
    classes.push("text-neutral-400");
  } else {
    classes.push(textColorMap[dsf_level]);
  }
  return concatClasses(classes);
};
export {
  getClasses,
  getIcon,
  getIconClasses
};
